var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9587 15.7082H15.7087V22.9582H13.292V15.7082H6.04199V13.2915H13.292V6.0415H15.7087V13.2915H22.9587V15.7082Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCard);
export default __webpack_public_path__ + "static/media/plus_card.0904c24a.svg";
export { ForwardRef as ReactComponent };